import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle2, Package } from 'lucide-react';
import AppTopHeader from '../components/AppTopHeader';

const BuyQRCodeSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const order = location.state?.order;

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white">
      <AppTopHeader hideBackButton />
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white rounded-3xl border border-emerald-100 shadow-sm p-8 md:p-10 text-center">
          <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
            <CheckCircle2 className="w-9 h-9 text-emerald-600" />
          </div>

          <p className="text-sm font-semibold text-emerald-700 uppercase tracking-wide mb-2">Order Confirmed</p>
          <h1 className="text-3xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Barlow' }}>
            QR Code order placed successfully
          </h1>
          <p className="text-slate-600 max-w-xl mx-auto mb-8">
            Your order has been received. We will process it shortly and you can track fulfillment updates from your dashboard.
          </p>

          <div className="grid md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
              <p className="text-xs font-medium uppercase tracking-wide text-slate-500 mb-1">Simple Order ID</p>
              <p className="text-xl font-bold text-slate-900">{order?.displayOrderId || 'Available in Dashboard'}</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
              <p className="text-xs font-medium uppercase tracking-wide text-slate-500 mb-1">Quantity</p>
              <p className="text-xl font-bold text-slate-900">{order?.quantity || '-'}</p>
            </div>
          </div>

          <div className="mt-6 rounded-2xl border border-blue-100 bg-blue-50 p-5 max-w-2xl mx-auto text-left">
            <div className="flex items-start gap-3">
              <Package className="w-5 h-5 text-blue-700 mt-0.5" />
              <div>
                <p className="text-sm font-semibold text-slate-900 mb-1">What happens next?</p>
                <ul className="text-sm text-slate-700 space-y-1 list-disc pl-5">
                  <li>Your order will appear in your dashboard for tracking.</li>
                  <li>We'll send you SMS updates for shipping and delivery.</li>
                  <li>Once received, scan and activate your QR codes to link them to your vehicle.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate('/dashboard')}
              className="px-6 py-3 rounded-xl bg-[#0DB504] text-white font-semibold hover:bg-[#0a9e03]"
            >
              View My Orders
            </button>
            <button
              onClick={() => navigate('/buy-qr')}
              className="px-6 py-3 rounded-xl border border-slate-300 text-slate-700 font-semibold hover:bg-slate-50"
            >
              Buy More QR Codes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyQRCodeSuccessPage;